import { render, staticRenderFns } from "./BandejaLinkPacienteReplicaComponente.vue?vue&type=template&id=979708fe&scoped=true"
import script from "./BandejaLinkPacienteReplicaComponente.vue?vue&type=script&lang=js"
export * from "./BandejaLinkPacienteReplicaComponente.vue?vue&type=script&lang=js"
import style0 from "./BandejaLinkPacienteReplicaComponente.vue?vue&type=style&index=0&id=979708fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979708fe",
  null
  
)

export default component.exports